<div class="bg-image flex-grow-1">
  <nz-page-header title="Защита на лични данни"/>
  <div class="container-lg">
    <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
      <main class="p-3">
        <p>
          „НУМИЗМАТ“ ЕООД, в качеството си на администратор на сайта <strong>collectoria.bg</strong>, обработва лични
          данни. Всички лични данни се обработват съгласно изискванията на Регламент (ЕС) 2016/679 (Общ регламент
          относно защитата на данните – ОРЗД) и българското законодателство.
        </p>
        <p class="fst-italic">
          Целта на настоящата политика е да осигури прозрачност, законосъобразност и защита на личната информация на
          всички посетители и потребители на сайта.
        </p>
        <p class="mt-4 mb-2">
          <strong>Политика за защита на личните данни</strong> (последно обновяване: 08.05.2025 г.)
        </p>
        <a
          class="btn btn-nz-outline-primary d-inline-flex align-items-center gap-2"
          href="https://collectoria.bg/assets/documents/politika-za-zashtita-na-lichni-danni-numizmat.pdf"
          target="_blank"
          rel="noopener">
          <i class="fa fa-file-pdf" aria-hidden="true"></i> Отвори документа (PDF)
        </a>
        <p class="mt-4 mb-2">
          <strong>Образец на заявление от субект на лични данни</strong> (последно обновяване: 08.05.2025 г.)
        </p>
        <a
          class="btn btn-nz-outline-primary d-inline-flex align-items-center gap-2"
          href="https://collectoria.bg/assets/documents/zaiavlenie-subekt-lichni-danni-numizmat.pdf"
          target="_blank"
          rel="noopener">
          <i class="fa fa-file-pdf" aria-hidden="true"></i> Отвори документа (PDF)
        </a>
      </main>
    </section>
  </div>
</div>
